// Camera family selection and model search for the FirmwareDownloadsElement.
// The selected family is kept in the URL (?family=exo) so it can be linked directly.

const FAMILY_PARAM = 'family';

// Model search combined with the interface filter buttons of one file table.
function initFirmwareSearch(container: HTMLElement): void {
    const input = container.querySelector<HTMLInputElement>('[data-firmware-search]');
    const buttons = Array.from(container.querySelectorAll<HTMLButtonElement>('[data-interface-filter]'));
    const rows = Array.from(container.querySelectorAll<HTMLTableRowElement>('tr[data-model]'));
    const noResults = container.querySelector<HTMLElement>('[data-firmware-noresults]');
    let activeInterface = '';

    function applyFilter(): void {
        const query = (input?.value || '').trim().toLowerCase();
        let visible = 0;
        rows.forEach(row => {
            const matchesModel = query === '' || (row.dataset.model || '').toLowerCase().includes(query);
            const matchesInterface = activeInterface === '' || row.dataset.interface === activeInterface;
            row.hidden = !(matchesModel && matchesInterface);
            if (!row.hidden) visible++;
        });
        if (noResults) noResults.hidden = visible > 0;
    }

    input?.addEventListener('input', applyFilter);
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            activeInterface = button.dataset.interfaceFilter || '';
            buttons.forEach(other => {
                const active = other === button;
                other.classList.toggle('is-active', active);
                other.setAttribute('aria-pressed', String(active));
            });
            applyFilter();
        });
    });
}

function initFirmwareDownloads(root: HTMLElement): void {
    const select = root.querySelector<HTMLSelectElement>('[data-firmware-family]');
    const entries = Array.from(root.querySelectorAll<HTMLElement>('.fwdl_entry'));

    root.querySelectorAll<HTMLElement>('[data-firmware-files]').forEach(initFirmwareSearch);

    if (!select) return;
    root.classList.add('is-enhanced');

    function showFamily(slug: string): void {
        entries.forEach(entry => entry.classList.toggle('is-active', slug !== '' && entry.dataset.family === slug));
    }

    const initial = new URLSearchParams(window.location.search).get(FAMILY_PARAM) || '';
    if (Array.from(select.options).some(option => option.value === initial)) {
        select.value = initial;
    }
    showFamily(select.value);

    select.addEventListener('change', () => {
        showFamily(select.value);
        const url = new URL(window.location.href);
        if (select.value) {
            url.searchParams.set(FAMILY_PARAM, select.value);
        } else {
            url.searchParams.delete(FAMILY_PARAM);
        }
        window.history.replaceState(null, '', url);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-firmware-downloads]').forEach(initFirmwareDownloads);
});
